import { Fragment, useCallback } from 'react';
import { NavigationIconButton } from '@cbhq/cds-web/buttons';
import { SelectOption } from '@cbhq/cds-web/controls/SelectOption';
import { Dropdown } from '@cbhq/cds-web/dropdown/Dropdown';
import { Icon } from '@cbhq/cds-web/icons';
import { Divider, VStack } from '@cbhq/cds-web/layout';
import { PopoverContentPositionConfig } from '@cbhq/cds-web/overlays/popover/PopoverProps';
import { TextBody } from '@cbhq/cds-web/typography/TextBody';
import { triggerResearchEventOnUserAction } from '@cbhq/user-research-web';

import { CLOUD_DOCS, CLOUD_FORUM, CLOUD_HELP } from ':cloud/utils/links';
import { openUrlInNewWindow } from ':cloud/utils/openUrlInNewWindow';

// TODO: fill in actual URLs when available
const options = [
  { value: 'Get support', to: CLOUD_HELP },
  { value: 'Documentation', to: CLOUD_DOCS },
  { value: 'Discord', to: CLOUD_FORUM },
  // { value: 'FAQs', to: CLOUD_HELP_FAQ }, // TODO: renable when FAQ link available
  { value: 'Send feedback' },
];

const USER_RESEARCH_EVENT_NAME = 'send_feedback';

const DROPDOWN_CONTENT_POSITION = { placement: 'bottom-end' } as PopoverContentPositionConfig;

function HelpDropdown() {
  return (
    <Dropdown
      content={<HelpDropdownContent />}
      showOverlay
      enableMobileModal
      contentPosition={DROPDOWN_CONTENT_POSITION}
    >
      <NavigationIconButton accessibilityLabel="Help Menu" name="helpCenterQuestionMark" />
    </Dropdown>
  );
}

function HelpDropdownContent() {
  const handlePress = useCallback((url?: string) => {
    if (!url) {
      return () => triggerResearchEventOnUserAction(USER_RESEARCH_EVENT_NAME);
    }
    return () => openUrlInNewWindow(url);
  }, []);
  return (
    <VStack>
      {options.map(({ value, to }, i) => (
        <Fragment key={value}>
          {i === options.length - 1 && <Divider />}
          <SelectOption
            value={value}
            title={
              <TextBody color="foregroundMuted" as="p">
                {value}
              </TextBody>
            }
            onPress={handlePress(to)}
            accessory={
              to?.includes('http') ? (
                <Icon size="s" name="externalLink" color="foregroundMuted" />
              ) : undefined
            }
          />
        </Fragment>
      ))}
    </VStack>
  );
}

export default HelpDropdown;
